<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-col cols="8"></b-col>
        <b-col cols="4">
          <b-form-input @input="onSearch" />
        </b-col>
      </b-col>
    </b-row>

    <b-table
      primary-key="cine_id"
      responsive
      show-empty
      :items="CinemasList"
      :fields="tableFields"
    >
      <template #cell(sr)="data">
        {{ data.index + 1 + (currentPage - 1) * perPage }}
      </template>

      <template #cell(qrcode)="data">
        <div v-if="FnBAppUrl" class="d-flex flex-column">
          <a :href="getFnBAppUrl(data.item.cine_id)">
            {{ getFnBAppUrl(data.item.cine_id) }}
          </a>

          <br />

          <qr-code :text="getFnBAppUrl(data.item.cine_id)"></qr-code>
        </div>
        <div v-else>
          <p>FnB App Base Url Not found in global options</p>
        </div>
      </template>

      <template #cell(screen)="data">
        <div>
          <b-form-select @input="onScreenSelected($event, data.item.cine_id)">
            <b-form-select-option :value="null">None</b-form-select-option>
            <b-form-select-option
              v-for="(screen, screen_index) in screensList[data.item.cine_id]"
              :value="screen"
              :key="'screen_' + screen_index"
            >
              {{ screen.screen_name }}
            </b-form-select-option>
          </b-form-select>
        </div>
      </template>

      <template #cell(seat)="data">
        <button
          :disabled="
            !(
              data &&
              data.item &&
              data.item.cine_id &&
              screenIds &&
              screenIds[data.item.cine_id]
            )
          "
          :class="[
            !(
              data &&
              data.item &&
              data.item.cine_id &&
              screenIds &&
              screenIds[data.item.cine_id]
            )
              ? 'btn-grey'
              : 'btn-blue',
          ]"
          v-on:click="getLinksForSeats($event, data)"
        >
          Get Seats URLs
        </button>
      </template>

      <template #footer>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
        />
      </template>
    </b-table>
  </div>
  <!-- //     </b-table>
//   </div>
// </template> -->
</template>

<script>
import {
  BTable,
  BPagination,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import MasterService from "@/services/MasterService";
import ScreenService from "@/services/ScreenService";

export default {
  components: { BTable, BPagination, BRow, BCol, BFormInput },
  data() {
    return {
      CinemasList: [],
      CinemasListCopy: [],

      FnBAppUrl: "",

      screenIds: {},

      screensList: {},

      tableFields: [
        {
          key: "sr",
          label: "SR",
        },
        {
          key: "cine_name",
          label: "Cinema Name",
          // sortable: true,
        },
        {
          key: "qrcode",
          label: "Qr Code",
        },
        {
          key: "screen",
          label: "Select Screen",
        },
        {
          key: "seat",
          label: "Seat QF",
        },
      ],

      // pagination
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
    };
  },
  methods: {
    getFnBAppUrl(cine_id) {
      let base = this.FnBAppUrl;
      let u = new URL("/place-order", base);

      if (cine_id) u.searchParams.append("cinema_id", cine_id);
      if (this.screenIds[cine_id])
        u.searchParams.append("screen_id", this.screenIds[cine_id]);

      return u.toString();
    },
    async loadScreens() {
      const response = await ScreenService.GetActiveScreens({
        activekey: "screen_is_active",
        columnName: "screen_order",
        conditionColName: "cinema_id",
        // conditionId: cine_id,
        // currentPage: 1,
        // limit: 10,
        // orderBy: "asc",
        // searchKey: "screen_name",
        // searchValue: "",
        tableName: "screens",
      });

      if (response.data.status) {
        // this.screensList[cine_id] = response.data.Records;
        // this.$forceUpdate();
        const screensList = {};
        for (const screen of response.data.Records) {
          if (screen.screen_is_active) {
            if (screensList[screen.cinema_id]) {
              screensList[screen.cinema_id].push(screen);
            } else {
              screensList[screen.cinema_id] = [screen];
            }
          }
        }
        this.screensList = screensList;
      }
    },

    onScreenSelected(screen, cine_id) {
      if (!screen) return;
      this.screenIds[cine_id] = screen.screen_id;

      const screenIds = this.screenIds;
      screenIds[cine_id] = screen.screen_id;
      this.screenIds = {};
      this.screenIds = {
        ...screenIds,
      };

      this.$forceUpdate();
    },

    onSearch(search) {
      if (search) {
        search = search.toLowerCase();
        this.CinemasList = this.CinemasListCopy.filter((cine) => {
          return cine.cine_name.toLowerCase().includes(search);
        });
      } else {
        this.CinemasList = this.CinemasListCopy;
      }
    },
    async getCinemaList() {
      try {
        const response = await MasterService.GetCinemas();
        const { data } = response;
        if (!data.status || !data.Records.length) {
          this.$toasted.show("Something went wrong");
          return;
        }

        this.CinemasList = data.Records;
        this.CinemasListCopy = data.Records;
        this.totalRows = data.Records.length;
        this.$forceUpdate();
      } catch (error) {
        console.error("Error in getting cinema list", error);
      }
    },
    async setFnBAppUrl() {
      const response = await MasterService.GetGlobalOptions();
      const { data } = response;
      if (!data.status || !data.Records.length) {
        this.$toasted.show("Cannot get FnB App Url");
        return;
      }

      const [option] = data.Records.filter((g) => g.go_key == "FNB_APP_URL");
      if (!option || !option.go_value) return;
      this.FnBAppUrl = option.go_value;
    },
    async getLinksForSeats(event, data) {
      try {
        let screen_id = this.getSafe(() => this.screenIds[data.item.cine_id]);

        console.log({
          data,
          "this.screenIds[data.item.cine_id]": this.getSafe(
            () => this.screenIds[data.item.cine_id]
          ),
          screen_id,
        });

        if (screen_id) {
          const { data: resp } = await MasterService.GetSeatURLForQR({
            screen_id,
          });

          console.log({ resp });

          if (resp && resp.status && resp.file) {
            window.open(resp.file, "_blank");
          } else {
            this.$toasted.show(resp.message);
          }
        }
      } catch (e) {
        this.$toasted.show(e.message);
      }
    },
  },
  beforeMount() {
    this.loadScreens();
    this.getCinemaList();
    this.setFnBAppUrl();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaFnBAppQrCodes/CinemaFnBAppQrCodes.vue